// import { ethers } from 'ethers';
// polygon
export const abiAddress = '0x4A5599a249fDC53bD4746e7d9078eDb7543bD0A9'
// export const SBNAddress = '0xe2d80d9e915bc53a6f119ae5a5e1a8931eb8d6a0' // polygon test net
export const SBNAddress = '0xadb39ffdf601470bdbac4597b3eea592bc336fff' // polygon main net
export const SBNStr = 'WSBN-abc123def456ghi789jkl' // polygon main net

export  function hashSBN(web3_sbn) {
    console.log('window.web3', window.web3);
    // Convert string to UTF-8 bytes
    const bytes = window.web3.utils.utf8ToHex(web3_sbn);
    console.log('bytes', bytes);
    // Calculate Keccak-256 hash
    const web3_sbn_hash = window.web3.utils.keccak256(bytes);
    console.log('web3_sbn_hash', web3_sbn_hash);
    return web3_sbn_hash;
}